export enum FinalDocumentType {
  BINDER = 'BINDER',
  INVOICE = 'INVOICE',
  ELMSURE_BINDER = 'ELMSURE_BINDER',
  ELMSURE_INVOICE = 'ELMSURE_INVOICE',
  ELMSURE_PAID_RECEIPT = 'ELMSURE_PAID_RECEIPT',
  FLOOD = 'FLOOD',
}

export enum CoverageType {
  PACKAGE = 'Package Coverage',
  PROPERTY = 'Property Coverage',
  LIABILITY = 'Liability Coverage',
  FLOOD = 'Flood'
}

export enum InsuranceAutomationStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE'
}

export const INSURANCE_STATUS_APPROVED = 'Approved';

export const INSURANCE_REVIEW_EVENT_TYPE = 'Insurance Review';
export const INSURANCE_REVIEW_EVENT_TYPE_V2 = 'New Insurance Review';

export enum AutomationEventTypes {
  ITEM_FLAGGED_EVENT = 'ITEM FLAGGED',
  ITEM_UNFLAGGED_EVENT = 'ITEM UNFLAGGED',
  ITEM_REVISION_FLAGGED_EVENT = 'ITEM REVISION FLAGGED',
  ITEM_REVISION_UNFLAGGED_EVENT = 'ITEM REVISION UNFLAGGED',
  ITEM_DATA_UPDATED = 'ITEM DATA UPDATED',
  ITEM_CLEAR_FLAGS = 'ITEM CLEAR FLAGS',
  ITEMS_SENT_FOR_RESOLUTIONS = 'ITEMS SENT FOR RESOLUTIONS',
}
